import { atom } from 'recoil';

import { CustomerAssetDetailsFiltersAtom } from './types';

export const customerAssetDetailsFilters = atom<CustomerAssetDetailsFiltersAtom>({
  key: 'customerAssetDetailsFilters',
  default: {},
});
